import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import clsx from 'clsx';

import { Wrapper } from '../NewHome';
import Modal from '../NewHome/components/Modal';
import SeoTags from '../../components/SeoComponent';
import Login from '../NewHome/components/Login';
import OtpModal from '../NewHome/components/OtpModal';
import SignUp from '../NewHome/components/SignUp';
import Header from '../BareFootMiniCourse/Header';
import MeetDocJen from '../GratefulForBody/MeetDocJen';
import Button from '../../ui-core/Button/Button';
import Testimonial from '../FullBodyLowImpact/Testimonials';
import {
  Features,
  Hero,
  PastChallengers,
  PlanBegins,
  Sample,
  TopBar,
} from './sections';
import { Video } from '../Lead/components';
import { JenHealthChallenge } from '../FullBodyMobility/components';
import Next30Days from '../Challenge/components/Next30Days';
import FAQSection from '../BodyParts/FAQSection';
import ReadyToExperience from './sections/ReadyToExperience';

import useWindowWidth from '../../hooks/useWindowWidth';
import { withFooter } from '../../hoc/withFooter';
import { useCourseDetail } from '../../hooks/useCourseDetail';
import {
  getDisplayType,
  isLoggedIn,
  logOutput,
  scrollToTop,
} from '../../utils/helpers';
import { getCanonicalLink, SeoTexts } from '../../services/SEO';
import { SEGMENT_EVENTS, trackEvent } from '../../utils/Segment';
import { MODAL_TYPE, TEXT_CONSTANT } from '../../constants/app';
import { COURSES_SLUGS } from '../../route';
import {
  moveToImproveTestimonials,
  moveToImproveThirtyDays,
  moveToImproveThirtyFAQs,
} from './static';

import './style.css';

const MoveToImprove = ({ history, match }) => {
  const [modalState, setModalState] = useState(null);
  const [countryCode, setCountryCode] = useState('us');
  const displayType = getDisplayType(useWindowWidth());
  const isMobileScreen = displayType === 'mobile';
  const { courseDetail, handleCourseRedirection, isLoading } = useCourseDetail(
    history,
    match,
  );
  const endDate = '03/06/2023';

  useEffect(() => {
    scrollToTop();
  }, []);

  const handleModalState = modalData => setModalState(modalData);

  const handleModalEvent = modalType => setModalState(modalType);

  useEffect(() => {
    axios
      .get('https://ipapi.co/json/')
      .then(response => {
        const data = response.data;
        setCountryCode(data.country_code.toLowerCase());
      })
      .catch(error => {
        logOutput(error);
      });
  }, []);

  const dialogClassName = (() => {
    switch (modalState) {
      case MODAL_TYPE.SUCCESS:
        return 'success-modal';
      case MODAL_TYPE.WAITLIST:
        return 'survey-modal';
      default:
        return undefined;
    }
  })();

  const handleClose = () => {
    setModalState(false);
  };

  const handleAuthFlow = (buttonTitle, eventType, section) => {
    trackEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
      button_title: buttonTitle,
      page: '30 Days of Strength and Mobility Page',
      section_title: `${section}`,
    });
    if (isLoggedIn()) {
      handleCourseRedirection();
    } else {
      trackEvent(SEGMENT_EVENTS.AUTH_FLOW_INITIATED, {
        page: '30 Days of Strength and Mobility Page',
        section_title: `${section}`,
      });
      handleModalEvent(eventType);
      if (isMobileScreen) {
        scrollToTop();
      }
    }
  };

  const renderModalContent = () => {
    switch (modalState) {
      case MODAL_TYPE.LOGIN:
        return (
          <Wrapper type={modalState} handleGoBack={() => setModalState(null)}>
            <Login
              page="30 Days of Strength and Mobility Page"
              countryCode={countryCode}
              handleModalState={handleModalState}
              handleModalEvent={handleModalEvent}
            />
          </Wrapper>
        );
      case MODAL_TYPE.OTP:
        return (
          <Wrapper type={modalState} handleGoBack={() => setModalState(null)}>
            <OtpModal
              page="30 Days of Strength and Mobility Page"
              handleModalState={handleModalState}
              handleModalEvent={handleModalEvent}
            />
          </Wrapper>
        );
      case MODAL_TYPE.SIGNUP:
        return (
          <Wrapper type={modalState} handleGoBack={() => setModalState(null)}>
            <SignUp
              page="30 Days of Strength and Mobility Page"
              countryCode={countryCode}
              handleModalState={handleModalState}
              handleModalEvent={handleModalEvent}
            />
          </Wrapper>
        );
      default:
        return null;
    }
  };

  const renderPageContent = () => (
    <div className="move-to-improve-page">
      <TopBar
        description="Sign up and get started on Day 0 Self-Assessments now!"
        endDate={endDate}
        hideTimeCounter
        loading={isLoading}
        onClick={handleAuthFlow}
        text={
          new Date() > new Date(endDate)
            ? TEXT_CONSTANT.POST_EARLY_BIRD_MOVE
            : TEXT_CONSTANT.EARLY_BIRD_DISCOUNT
        }
      />
      <Header onClick={handleAuthFlow} />
      <Hero
        loading={isLoading}
        courseDetail={courseDetail}
        onClick={handleAuthFlow}
      />
      <Video
        headerText=""
        videoURL="https://www.youtube.com/embed/nh1JlGyk42o"
      />
      <div className="d-flex justify-content-center mb-5">
        <Button
          class="sign-up-button-new"
          isDisabled={isLoading}
          isLoading={isLoading}
          onClick={() =>
            handleAuthFlow(
              TEXT_CONSTANT.JOIN_THE_COURSE,
              MODAL_TYPE.LOGIN,
              'About 30 Days of Strength & Mobility Course!',
            )
          }
          text={TEXT_CONSTANT.JOIN_THE_COURSE}
        />
      </div>
      <Testimonial testimonials={moveToImproveTestimonials} />
      <Features
        courseDetail={courseDetail}
        loading={isLoading}
        onClick={handleAuthFlow}
      />
      {/* <WinPrizes
        btnText={TEXT_CONSTANT.CLICK_TO_JOIN_NOW}
        headerImage={IMAGE_CONSTANT.winnerPrizes1}
        loading={isLoading}
        onClick={handleAuthFlow}
        sections={winningPrizes}
        title={TEXT_CONSTANT.ENROLL_IN_MOVE_TO_IMPROVE_PLAN}
      /> */}
      <PlanBegins loading={isLoading} onClick={handleAuthFlow} />
      <Next30Days
        backgroundColor="#FFFFFF"
        description="(31 videos over 30 days!)"
        sections={moveToImproveThirtyDays}
        text={TEXT_CONSTANT.WHAT_YOU_GET_OVER_30}
      />
      <div className="d-flex justify-content-center mb-5">
        <Button
          class="sign-up-button-new"
          isDisabled={isLoading}
          isLoading={isLoading}
          onClick={() =>
            handleAuthFlow(
              TEXT_CONSTANT.JOIN_THE_COURSE,
              MODAL_TYPE.LOGIN,
              TEXT_CONSTANT.WHAT_YOU_GET_UPPER_BACK_AND_NECK_PLAN,
            )
          }
          text={TEXT_CONSTANT.JOIN_THE_COURSE}
        />
      </div>
      <Sample
        courseDetail={courseDetail}
        loading={isLoading}
        onClick={handleAuthFlow}
      />
      <JenHealthChallenge
        backgroundColor="#5E848D"
        btnClass="sign-up-button-new"
        btnText={TEXT_CONSTANT.REGISTER}
        hideTimeCounter
        loading={isLoading}
        onClick={handleAuthFlow}
        startsAt={endDate}
        title="Join 30 Days of Strength and Mobility"
      />
      <FAQSection
        buttonText={TEXT_CONSTANT.LETS_DO_THIS}
        onClick={handleAuthFlow}
        faqs={moveToImproveThirtyFAQs}
      />
      <PastChallengers />
      <ReadyToExperience loading={isLoading} onClick={handleAuthFlow} />
      <MeetDocJen backColor="#C1F0FC" />
    </div>
  );

  const renderContentMobile = () => {
    if (modalState) {
      return renderModalContent();
    } else {
      return renderPageContent();
    }
  };

  return (
    <div className={clsx('main', isMobileScreen && modalState && 'h-100')}>
      {isMobileScreen &&
      ![MODAL_TYPE.SUCCESS, MODAL_TYPE.WAITLIST].includes(modalState)
        ? renderContentMobile()
        : renderPageContent()}
      {!isMobileScreen && (
        <Modal
          dialogClassName={dialogClassName}
          show={Boolean(modalState)}
          handleClose={handleClose}
        >
          {renderModalContent()}
        </Modal>
      )}
      <SeoTags
        title={SeoTexts.MOVE_TO_IMPROVE_TITLE}
        metaDescription={SeoTexts.MOVE_TO_IMPROVE_DESCRIPTION}
        canonicalLink={getCanonicalLink('/' + COURSES_SLUGS.MOVE_TO_IMPROVE)}
        ogImgUrl={SeoTexts.MOVE_TO_IMPROVE_OG_IMAGE_URL}
        twitterImgUrl={SeoTexts.MOVE_TO_IMPROVE_TWITTER_IMAGE_URL}
      />
    </div>
  );
};

MoveToImprove.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object,
};

export default withFooter(MoveToImprove);
